import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListGroup,{ref:"refVListGroup",staticClass:"vertical-nav-menu-group text--primary",scopedSlots:_vm._u([{key:"prependIcon",fn:function(){return [_c(VIcon,{class:{'alternate-icon-small': !_vm.icon}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])]},proxy:true},{key:"activator",fn:function(){return [_c(VListItemTitle,[_vm._v(" "+_vm._s(_vm.title)+" ")])]},proxy:true}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }